<template>
  <v-row dense>
    <v-col
      v-for="config in configs"
      :key="config.propName"
      :cols="getCols(config.cols)"
      :sm="getSm(config.sm)"
      :md="getMd(config.md)"
      :offset-sm="getOffsetSm(config.offsetSm)"
      :offset-md="getOffsetMd(config.offsetMd)"
      :class="getOffsetClass(config)"
    >
      <div
        v-if="config.sectionTitle"
        class="sectionTitle"
      >
        {{ config.sectionTitle }}
      </div>
      <div
        v-show="!config.hide"
        v-else
      >
        <!-- <v-text-field
          v-model="editedItem[config.propName]"
          :label="config.label"
        ></v-text-field> -->
        <div
          v-if="config.toplabel"
          class="ml-2 mb-1"
        >
          {{ config.toplabel }}<span
            v-if="isRequired(config.type)"
            style="color:red"
          >*</span>
        </div>
        <CheckboxGroup
          v-if="isCheckboxes(config)"
          :ref="config.propName"
          :config="config"
          @input="val=>handleInput(config.propName,val)"
        >
        </CheckboxGroup>
        <RadioGroup
          v-if="isRadio(config)"
          :ref="config.propName"
          v-model="editedItem[config.propName]"
          :config="config"
          @input="val=>handleInput(config.propName,val)"
        >
        </RadioGroup>
        <universal-input
          v-else
          :ref="config.propName"
          v-model="editedItem[config.propName]"
          :config="config"
          @input="val=>handleInput(config.propName,val)"
        />
      </div>
      <div v-if="debug">
        <div>For Debug</div>
        <pre>{{ JSON.stringify(config,null,4) }}</pre>
      </div>
    </v-col>
  </v-row>
</template>
<script>
import UniversalInput from './UniversalInput'
import CheckboxGroup from './CheckboxGroup'
import RadioGroup from './RadioGroup'

export default {
  name: 'InputContainer',
  components: {
    UniversalInput,
    CheckboxGroup,
    RadioGroup,
  },
  props: {
    configs: {
      type: Array,
      default() {
        return [
          {
            propName: 'name',
            label: 'Dessert name',
          },
          {
            propName: 'calories',
            label: 'Calories',
          },
          {
            propName: 'fat',
            label: 'Fat (g)',
          },
          {
            propName: 'carbs',
            label: 'Carbs (g)',
          },
          {
            propName: 'protein',
            label: 'Protein (g)',
          },
        ]
      },
    },
    record: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      editedItem: {},
      debug: false,
    }
  },
  watch: {
    record(val) {
      console.log('this.record', this.record)
      Object.keys(this.record).forEach(key => {
      // key: the name of the object key
      // index: the ordinal position of the key within the object
        this.$set(this.editedItem, key, this.record[key])
      })
      console.log('this.editedItem', this.editedItem)

      // return val || this.close()
    },
  },
  mounted() {
    Object.keys(this.editedItem).forEach(key => {
      if (this.editedItem[key] === undefined) {
        delete this.editedItem[key]
      }
    })
    console.log('this.configs', this.configs)
    const defaultRadioes = this.configs.filter(config => config.type && (config.type.name === 'radio' || config.type.name === 'radioGroup') && config.defaultValue)
    console.log('defaultRadioes', defaultRadioes)
    defaultRadioes.forEach(defaultRadio => {
      this.$set(this.editedItem, defaultRadio.propName, defaultRadio.defaultValue)
    })
    console.log('this.record', this.record)
    Object.keys(this.record).forEach(key => {
      // key: the name of the object key
      // index: the ordinal position of the key within the object
      this.$set(this.editedItem, key, this.record[key])
    })
    console.log('this.editedItem', this.editedItem)
  },
  methods: {
    handleInput(key, value) {
      // added by Jason 20230320
      this.$emit('input', key, value)
    },
    updateValue(key, value) {
      // console.log('inputeContainer refs', this.$refs, key, value)
      this.$nextTick(() => {
        this.editedItem[key] = value
        this.$refs[key][0].updateValue(value)
      })
    },
    getItems(config) {
      if (config.type.name === 'radio' || config.type.name === 'checkbox') {
        if (config.type.storeName) {
          return this.$store.getters[this.storeName]
        }
      }

      return config.type.groupItems || []
    },
    getRadioConfig(config, radioConfig) {
      const itemConfig = {}
      itemConfig.propName = `${config.propName}_${radioConfig.itemName}`
      itemConfig.label = radioConfig.label
      itemConfig.type = { name: 'radio' }

      return itemConfig
    },

    isRadio(config) {
      if (config.type && config.type.name === 'radioGroup') {
        return true
      }

      return false
    },
    isCheckboxes(config) {
      if (config.type && config.type.name === 'checkboxGroup') {
        return true
      }

      return false
    },
    isRequired(type) {
      if (type && type.required) {
        return true
      }

      return false
    },
    getCols(cols) {
      return cols || 12
    },
    getSm(sm) {
      return sm || 12
    },
    getMd(md) {
      return md || 12
    },
    getOffsetSm(offsetSm) {
      return offsetSm || 0
    },
    getOffsetMd(offsetMd) {
      return offsetMd || 0
    },
    getOffsetClass(config) {
      let offsetRightClass = ''
      const mapping = [
        'xs', 'sm', 'md', 'lg', 'xl',
      ]
      let index = mapping.indexOf(this.$vuetify.breakpoint.name)
      while (index >= 0) {
        const capLetter = mapping[index].charAt(0).toUpperCase() + mapping[index].slice(1)
        const configName = `offsetRight${capLetter}`
        if (config[configName]) {
          offsetRightClass += ` offset-right-${mapping[index]}-${config[configName]}`
        }
        index -= 1
      }

      // console.log('offsetRightClass', offsetRightClass)
      return offsetRightClass
    },
  },
}
</script>
<style>
  .sectionTitle{
    font-size: 2rem;

    white-space: nowrap;
    text-align: left;
    font-family: Source Han Sans HK;
    font-style: normal;
    font-weight: bold;
    color: rgba(60,59,59,1);
  }
</style>
